import { useLazyQuery } from '@apollo/client/react';
import { useAtomValue } from 'jotai';
import { useEffect } from 'react';

import { GetB2cloudSettingForDeliveryDocument } from '~/graphql/generated/graphql';
import { getMe } from '~/graphql/utility';
import { b2CloudDownloadModalState } from '~/state/reception/atoms';

export const useFetchB2cloudSetting = () => {
  const { isOpen } = useAtomValue(b2CloudDownloadModalState);

  const [getB2cloudSetting, { data, loading }] = useLazyQuery(GetB2cloudSettingForDeliveryDocument);

  const isEnabled = data ? !!getMe(data)?.organization.b2cloudSetting?.data.enable : false;

  useEffect(() => {
    if (isOpen) {
      getB2cloudSetting();
    }
  }, [getB2cloudSetting, isOpen]);

  return { loading, enabled: isEnabled };
};
